import { Box, useTheme } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

export default function ConfirmationPageWrapper({ children }: Props) {
    const theme = useTheme();
    return (
        <Box
            sx={{
                minHeight: '100vh',
                width: '100vw',
                backgroundColor: theme.palette.neutral.darkBlue,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            {children}
        </Box>
    );
}
